import { useEffect, useState } from 'react';
import cx from 'classnames';
import { useIsRTL } from '../../../locale';
import { TableRegions } from '../TableRegions';
import { SelectionCheckBox, SelectionRadioButton, shouldShowCheckbox } from './internal';
import cn from '../Table.css.json';
import '../Table.css';
import { jsx as _jsx } from "react/jsx-runtime";
const isRowSelected = (rowIndex, itemData) => {
  const {
    preference,
    getRowIdentifier,
    getSelectionState
  } = itemData;
  if (itemData.dragging === true) return false;
  const selectionState = itemData.getSelectionCheckboxState;
  const selectionStateOverride = selectionState ? selectionState(getRowIdentifier(rowIndex)) : getSelectionState?.(getRowIdentifier(rowIndex));
  return selectionStateOverride !== undefined ? selectionStateOverride : preference?.selectAll === true || !!preference?.selectedRows?.has(getRowIdentifier(rowIndex));
};
const SelectionContent = props => {
  const isRTL = useIsRTL();
  const {
    rowIndex,
    itemData
  } = props;
  const selected = itemData.preference?.selectAll;
  const hideUnselectedSelectionControl = itemData.hideUnselectedSelectionControl;
  const [displayState, setDisplayState] = useState(hideUnselectedSelectionControl ? 'none' : 'block');
  const focused = itemData.lastFocusedCell?.rowIndex === rowIndex && itemData.lastFocusedCell?.colIndex === 0 && itemData.focusIndicator === 'visible';
  useEffect(() => {
    hideUnselectedSelectionControl && setDisplayState(selected || focused ? 'block' : 'none');
  }, [selected, focused, hideUnselectedSelectionControl]);
  useEffect(() => {
    if (itemData.hideUnselectedSelectionControl === false) setDisplayState('block');
  }, [itemData.hideUnselectedSelectionControl]);
  const {
    getRowIdentifier,
    hideSelectionControl
  } = itemData;
  const rowKey = getRowIdentifier(rowIndex);
  const count = itemData.preference?.selectedRows?.size || 0;
  const {
    selectedCell
  } = props;
  const getSelectionCheckboxStyle = () => {
    // when the selection column is hidden, the hiding/unhiding is handled at the cell level
    const hoverOnParent = itemData.hideSelectionControlColumn;
    if (hoverOnParent === true) return {
      ...props.style,
      paddingRight: isRTL ? '0px' : '5px',
      paddingLeft: isRTL ? '5px' : '0px'
    };
    return {
      ...props.style,
      ...{
        display: selectedCell || count > 0 ? 'block' : displayState
      }
    };
  };
  return /*#__PURE__*/_jsx("div", {
    className: props.className,
    onContextMenu: event => {
      event.preventDefault();
    },
    onMouseDown: e => {
      if (e.shiftKey) e.preventDefault();
      itemData.refTop.current?.focus({
        preventScroll: true
      });
    },
    onMouseOver: () => {
      hideUnselectedSelectionControl && setDisplayState('block');
    },
    onMouseLeave: () => {
      hideUnselectedSelectionControl && setDisplayState(selectedCell || focused ? 'block' : 'none');
    },
    children: hideSelectionControl?.(rowKey) === true ? null : shouldShowCheckbox(itemData.selectionMode) ? /*#__PURE__*/_jsx(SelectionCheckBox, {
      itemData: itemData,
      rowIndex: rowIndex,
      style: getSelectionCheckboxStyle(),
      selected: selectedCell,
      selectAll: props.selectAll,
      ariaLabel: props.ariaLabel,
      ariaLabelledBy: props.ariaLabelledBy
    }) : /*#__PURE__*/_jsx(SelectionRadioButton, {
      itemData: itemData,
      rowIndex: rowIndex,
      style: {
        ...props.style
      },
      selected: !!selectedCell,
      ariaLabel: props.ariaLabel,
      ariaLabelledBy: props.ariaLabelledBy
    })
  });
};
export const SelectAllCellContent = props => {
  const {
    style,
    itemData
  } = props;
  return /*#__PURE__*/_jsx(SelectionContent, {
    itemData: props.itemData,
    rowIndex: -1,
    style: style,
    selectedCell: itemData.preference?.selectAll,
    className: cn.selectionCell,
    selectAll: true
  });
};
export const SelectionCellContent = props => {
  const {
    rowIndex,
    itemData
  } = props;
  const selectedCell = isRowSelected(rowIndex, itemData);
  const hideSelectionControlColumn = itemData.hideSelectionControlColumn;
  return /*#__PURE__*/_jsx(SelectionContent, {
    itemData: props.itemData,
    style: props.style,
    rowIndex: props.rowIndex,
    selectedCell: selectedCell,
    ariaLabel: props.ariaLabel,
    ariaLabelledBy: props.ariaLabelledBy,
    className: cx(itemData.buildCellBorderStyles(itemData.getRowIdentifier(props.rowIndex)), hideSelectionControlColumn !== true && cn.selectionCell, selectedCell === true && cn.selected, (itemData.pressedCell?.region === TableRegions.Data || itemData.pressedCell?.region === TableRegions.RowHeader) && rowIndex === itemData.pressedCell.rowIndex && itemData.pressEntireRow && cn.pressed)
  });
};
//# sourceMappingURL=SelectionCellContent.js.map